import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import "dayjs/locale/ru";
import { fmtTimeHM } from "../../extensions/utils";
import { getRecordBackground, getRecordLabel, getRecordOccupancy } from "./records-status";
import "./records-month.css";

dayjs.extend(isoWeek);
dayjs.locale("ru");

const WEEKDAYS = ["пн", "вт", "ср", "чт", "пт", "сб", "вс"];
const MAX_CHIPS = 4;

const getMonthDays = (date) => {
  const start = date.startOf("month").startOf("isoWeek");
  const end = date.endOf("month").endOf("isoWeek");
  const days = [];
  let cursor = start;
  while (cursor.isBefore(end) || cursor.isSame(end, "day")) {
    days.push(cursor);
    cursor = cursor.add(1, "day");
  }
  return days;
};

/** Месячное расписание: сетка дней с чипами записей */
const RecordsMonth = ({ date, records, onOpenRecord, onOpenDay }) => {
  const days = getMonthDays(date);
  const now = dayjs();
  const byDay = {};
  records.forEach(record => {
    if (!record.start) return;
    const key = record.start.format("YYYY-MM-DD");
    if (!byDay[key]) byDay[key] = [];
    byDay[key].push(record);
  });
  Object.keys(byDay).forEach(key => {
    byDay[key].sort((a, b) => a.start.valueOf() - b.start.valueOf());
  });

  return (
    <div className="records-month">
      <div className="records-month-head">
        {WEEKDAYS.map((name, index) => (
          <div key={name} className={`records-month-dow${index >= 5 ? " is-weekend" : ""}`}>{name}</div>
        ))}
      </div>
      <div className="records-month-grid">
        {days.map(day => {
          const key = day.format("YYYY-MM-DD");
          const dayRecords = byDay[key] || [];
          const visible = dayRecords.slice(0, MAX_CHIPS);
          const rest = dayRecords.length - visible.length;
          const occupancySum = dayRecords.reduce((acc, record) => {
            const clients = (record.cnts || []).filter(i => i.objectVid === 1).length;
            return {
              booked: acc.booked + clients,
              total: acc.total + (record.maxClients || 0),
            };
          }, { booked: 0, total: 0 });
          return (
            <div
              key={key}
              className={[
                "records-month-cell",
                day.isoWeekday() >= 6 ? "is-weekend" : "",
                day.month() !== date.month() ? "is-outside" : "",
                day.isSame(now, "day") ? "is-today" : "",
              ].filter(Boolean).join(" ")}
              onClick={() => onOpenDay(day)}
            >
              <div className="records-month-cell-head">
                <span className="records-month-date">{day.date()}</span>
                {occupancySum.total > 0 ? (
                  <span className="records-month-load">{occupancySum.booked}/{occupancySum.total}</span>
                ) : dayRecords.length > 0 ? (
                  <span className="records-month-load">{dayRecords.length}</span>
                ) : null}
              </div>
              <div className="records-month-events">
                {visible.map(record => {
                  const occupancy = getRecordOccupancy(record);
                  return (
                    <button
                      type="button"
                      key={record.id}
                      className="records-month-chip"
                      style={{ backgroundColor: getRecordBackground(record) }}
                      title={`${fmtTimeHM(record.start)} ${getRecordLabel(record)}`}
                      onClick={e => {
                        e.stopPropagation();
                        onOpenRecord(record.id);
                      }}
                    >
                      {fmtTimeHM(record.start)}{occupancy ? ` ${occupancy}` : ""} {getRecordLabel(record)}
                    </button>
                  );
                })}
                {rest > 0 ? (
                  <button
                    type="button"
                    className="records-month-more"
                    onClick={e => {
                      e.stopPropagation();
                      onOpenDay(day);
                    }}
                  >
                    ещё {rest}
                  </button>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RecordsMonth;
